import { ref, inject, onMounted, onBeforeUnmount } from 'vue';
import { createConsumer } from '@rails/actioncable';

export function useCable() {
  return inject('actionCableConsumer');
}

export function useChannel(...args) {
  const consumer = useCable();
  let channel = ref(null);

  onMounted(() => {
    channel.value = consumer.subscriptions.create(...args);
  });

  onBeforeUnmount(() => {
    channel.value.unsubscribe();
    channel.value = null;
  });

  return channel;
}

export default {
  install(app) {
    app.provide('actionCableConsumer', createConsumer());
  },
};
